module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4gujz"))).then(() => parcelRequire('d0iPb'));